import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import MapView from '../components/MapView';
import LoadingSpinner from '../components/LoadingSpinner';
import { immobilisationsAPI, categoriesAPI, servicesAPI } from '../services/api';
import { toast } from 'react-toastify';
import ExportPDFButton from '../components/ExportPDFButton';

const CartePage = () => {
  const [immobilisations, setImmobilisations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCategory, setFilterCategory] = useState('');
  const [filterService, setFilterService] = useState('');

  useEffect(() => {
    loadData();
  }, [filterCategory, filterService]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [immoRes, catRes, servRes] = await Promise.all([
        immobilisationsAPI.getAll({
          category: filterCategory,
          service: filterService,
        }),
        categoriesAPI.getAll(),
        servicesAPI.getAll(),
      ]);

      setImmobilisations(immoRes.data.data || immoRes.data);
      setCategories(catRes.data.data || []);
      setServices(servRes.data.data || []);
    } catch (error) {
      toast.error('Erreur lors du chargement de la carte');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="app-layout">
        <Sidebar />
        <div className="main-content">
          <Header />
          <div className="page-content" id="page-content">
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="page-content" id="page-content">
          <div className="page-header">
            <h1 className="page-title">Carte des Immobilisations</h1>
            <ExportPDFButton title="OGP IMMO - Carte" fileName="carte-ogp-immo" orientation="landscape" />
          </div>

          {/* Filters */}
          <div className="card" style={{ marginBottom: '1.5rem', padding: '1.5rem' }}>
            <div className="filter-group">
              <div className="filter-item">
                <label>Catégorie</label>
                <select
                  value={filterCategory}
                  onChange={(e) => setFilterCategory(e.target.value)}
                >
                  <option value="">Tous</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.nom}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-item">
                <label>Service</label>
                <select
                  value={filterService}
                  onChange={(e) => setFilterService(e.target.value)}
                >
                  <option value="">Tous</option>
                  {services.map((svc) => (
                    <option key={svc.id} value={svc.id}>
                      {svc.nom}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="card">
            <MapView immobilisations={immobilisations} />
          </div>

          {/* Info */}
          <div
            style={{
              marginTop: '1.5rem',
              padding: '1rem',
              backgroundColor: 'var(--bg-light)',
              borderRadius: 'var(--radius-md)',
              textAlign: 'center',
              color: 'var(--text-light)',
            }}
          >
            <p>{immobilisations.length} immobilisation(s) avec localisation GPS</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartePage;
